import { useState } from 'react';

export const REGULAR_SHOW_UNIT_AUTOCOMPLETE_KEY =
  'show-unit-autocomplete-field';
export const COMPLIANCE_SHOW_UNIT_AUTOCOMPLETE_KEY =
  'show-compliant-unit-autocomplete-field';

export const loadShowUnitAutocompleteFromStorage = (key: string) => {
  try {
    const item = localStorage.getItem(key);
    if (!item) {
      return true;
    }

    return JSON.parse(item);
  } catch (e) {
    return true;
  }
};

export const saveShowUnitAutocompleteToStorage = (
  key: string,
  value: boolean,
) => {
  return localStorage.setItem(key, JSON.stringify(value));
};

export const useUnitFieldVisibility = (
  key = REGULAR_SHOW_UNIT_AUTOCOMPLETE_KEY,
) => {
  const [isShowUnitAutocomplete, setIsShowUnitAutocomplete] = useState(
    loadShowUnitAutocompleteFromStorage(key),
  );

  const showUnitAutocompleteField = () => {
    setIsShowUnitAutocomplete(true);
    saveShowUnitAutocompleteToStorage(key, true);
  };

  const showRegularUnitField = () => {
    setIsShowUnitAutocomplete(false);
    saveShowUnitAutocompleteToStorage(key, false);
  };

  return {
    isShowUnitAutocomplete,
    showUnitAutocompleteField,
    showRegularUnitField,
  };
};
